// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"StudioFeaturesNavigationBar_titleContainer__O8O_5","link":"StudioFeaturesNavigationBar_link__S3LqB"};